/**
 * WI Quick View Image
 *
 * Swaps the Quick View drawer image on variant change. The drawer renders an
 * fg-image block rather than media-gallery, so nothing else in the theme updates it.
 *
 * Usage: <wi-quick-view-image> wrapping the drawer's product image.
 */
class WiQuickViewImage extends HTMLElement {
  #controller = new AbortController();

  connectedCallback() {
    this.closest('dialog')?.addEventListener('variant:update', this.#handleVariantUpdate, {
      signal: this.#controller.signal,
    });
  }

  disconnectedCallback() {
    this.#controller.abort();
  }

  /**
   * @param {Event & {detail?: any}} event
   */
  #handleVariantUpdate = (event) => {
    const source = event.detail?.resource?.featured_media?.preview_image?.src;
    const image = this.querySelector('img');
    if (!source || !(image instanceof HTMLImageElement)) return;

    const url = new URL(source, window.location.origin);
    url.searchParams.set('width', '800');

    image.removeAttribute('srcset');
    image.src = url.toString();
  };
}

customElements.define('wi-quick-view-image', WiQuickViewImage);
